import { render, staticRenderFns } from "./TransactionItems.vue?vue&type=template&id=5f0eba2a&scoped=true"
import script from "./TransactionItems.vue?vue&type=script&lang=js"
export * from "./TransactionItems.vue?vue&type=script&lang=js"
import style0 from "./TransactionItems.vue?vue&type=style&index=0&id=5f0eba2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0eba2a",
  null
  
)

export default component.exports